import { render, staticRenderFns } from "./WavesComponent.vue?vue&type=template&id=9308744c"
import script from "./WavesComponent.vue?vue&type=script&lang=js"
export * from "./WavesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports